/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Liable_Vehicles_TitleInputs */

const en_case_section_liable_vehicles_title = /** @type {(inputs: Case_Section_Liable_Vehicles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liable vehicles`)
};

const pt_br2_case_section_liable_vehicles_title = /** @type {(inputs: Case_Section_Liable_Vehicles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veículos terceiros`)
};

/**
* | output |
* | --- |
* | "Liable vehicles" |
*
* @param {Case_Section_Liable_Vehicles_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_liable_vehicles_title = /** @type {((inputs?: Case_Section_Liable_Vehicles_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Liable_Vehicles_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_liable_vehicles_title(inputs)
	return pt_br2_case_section_liable_vehicles_title(inputs)
});